var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state)?_c('div',{staticClass:"info-bar"},[_c('div',{staticClass:"info-bar__inner",on:{"click":_vm.goLink}},[_c('p',{staticClass:"dex-desc"},[_vm._v("🚀 Go to MEVerse DEX and get MEV to start playing games!")])]),_c('v-btn',{staticClass:"info-bar__close",on:{"click":_vm.goDexBarClose}},[_vm._v("닫기")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }